export default __webpack_public_path__ + "static/media/Human4.3f48a78b.png";